"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ChampionatIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("../../SvgIcon"));

var _ref = /*#__PURE__*/_react.default.createElement("path", {
  d: "M20.09 16.101c0 2.229-.454 3.9-1.272 5.2-2 2.88-5.636 4.736-7.818 5.386-2.182-.65-5.818-2.507-7.818-5.386-.818-1.3-1.273-2.971-1.273-5.2V2.636h18.182v13.465zM.09.786V16.05c0 2.59.546 4.626 1.637 6.198C4 25.67 8.364 27.89 11 28.537c2.636-.647 7-2.867 9.273-6.29 1.09-1.572 1.636-3.607 1.636-6.198V.786H.091zm11.82 10.055c0 .635-.274.907-.91.907h-.91c-.635 0-.908-.272-.908-.907V4.486H3.727v7.262c0 1.362.182 2.451.91 3.178.727.726 1.545.907 3.181.907h2.455c.636 0 1.363-.09 1.636-.363v8.442c1.91-.817 4.182-2.27 5.455-4.085.636-.907.909-2.178.909-3.994V4.486h-6.364v6.355zm-5.274 6.92c-1.181 0-2.363-.357-2.909-1.249.091 1.516.364 2.586.91 3.388 1.272 1.783 3.545 3.21 5.454 4.012V17.76H6.636z",
  fillRule: "evenodd"
});

function ChampionatIcon(props) {
  return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 22 29"
  }, props), _ref);
}

ChampionatIcon.displayName = 'ChampionatIcon';
ChampionatIcon.defaultProps = {
  color: '#f47820'
};